import '../../scripts/common';
import 'animate.css/animate.css';

import '../../scripts/autosize';
import '../../scripts/animate';
import '../../scripts/picture';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Field from '../../components/base/Field';
import Select from '../../components/base/Select';
import Categories from '../../components/simple/Categories';

import PageScrollBtn from '../../components/simple/PageScrollBtn';
import ArticleMiniCard from '../../components/ArticleMiniCard';
import ArticlesMiniList from '../../components/ArticlesMiniList';
import Spinner from '../../components/base/Spinner';
import Radio from '../../components/base/Radio';
import Breadcrumbs from '../../components/base/Breadcrumbs';
import './styles.css';

import Pagination from '../../components/base/Pagination';
import initAjaxPagination from '../../scripts/backend/pagination';

$(() => {
    Header.create();
    Footer.create();
    Field.create();
    Spinner.create();
    Radio.create();
    initSelect();
    Categories.create();
    Pagination.create();
    PageScrollBtn.create();
    ArticlesMiniList.create();
    ArticleMiniCard.create();
    Breadcrumbs.create();
    initAjaxPagination();
});

function initSelect() {
    const selectSingleDefaultObj = new Select($('.advices__select-block'));
    selectSingleDefaultObj.init({
        isSearch: false,
    });
}

/**
 * Изменение категории статей для раздела "Советы по уходу"
 */
// eslint-disable-next-line func-names
$(document).on('click', '.advices__list-link', function(event) {
    event.preventDefault();
    $('.advices__list-link.advices__list-link--active').removeClass('advices__list-link--active');
    $(this).addClass('advices__list-link--active');
    const type = $(this).attr('id');

    $.ajax({
        url: '/api/internal/component/articles:articles.list',
        method: 'post',
        data: {
            type,
        },
        success(data) {
            // eslint-disable-next-line no-restricted-globals, no-useless-concat
            history.pushState({ type }, '', `${'/advices/?' + 'type='}${type}`);
            // eslint-disable-next-line vars-on-top
            var block = $('.advices__items');
            block.fadeOut('fast');
            block.html(data);
            block.fadeIn('fast');
        },
    });
});
